import React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

export default function ConfirmDialog(props) {
	const {
		open,
		onClose,
		onCancel,
		onConfirm,
		title,
		description,
		okText,
		cancelText,
		noCancel = false,
		...other
	} = props;

	return (
		<div>
			<Dialog
				open={open}
				disableEscapeKeyDown
				maxWidth="xs"
				aria-labelledby="confirmation-dialog-title"
				{...other}
			>
				<DialogTitle id="alert-dialog-confirm"> {title || "Are you sure?"} </DialogTitle>
				<DialogContent dividers>
					<DialogContentText id="alert-dialog-description">
						{props.children ? props.children : description}
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button
						onClick={() => {
							onConfirm && onConfirm();
							onClose();
						}}
						color="primary"
					>
						{okText || "Confirm"}
					</Button>

					{!noCancel && (
						<Button
							autoFocus
							color="primary"
							onClick={() => {
								onCancel && onCancel();
								onClose();
							}}
						>
							{cancelText || "Cancel"}
						</Button>
					)}
				</DialogActions>
			</Dialog>
		</div>
	);
}
